import React, { useState } from "react";
import { Tag } from "antd";
import confirmBox from "../../CoreComponents/confirmBox";
import { showMessage } from "../../Functionalities/Functions";
import { applyLinks, previewLinks } from "./umbrellaData";

const tidy = (name) => name.trim().split(/\s+/).join(" ");
const membersLine = (group) => group.categories.map((row) => `${tidy(row.name)} (${row.products})`).join(", ");
const foldLine = (move) => `${move.franchise}: ${move.merge_names.map(tidy).join(", ")} → ${tidy(move.keep_name)} (${move.products} products)`;

export default function LinkExisting({ onApplied }) {
  const [preview, setPreview] = useState(null);
  const [fold, setFold] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    const reply = await previewLinks();
    setBusy(false);
    if (reply.error) showMessage(reply.error, "danger", "Could not preview", "top", "top-right", 0);
    else setPreview(reply);
  };

  const apply = () =>
    confirmBox({
      title: `Link ${preview.category_count} menu categories?`,
      message: fold
        ? "Same-word sections inside each franchise are merged too. That renames those menu sections and cannot be undone here."
        : "Menus do not change. The categories are only grouped for the app's category row.",
      yesLabel: "Link them",
      noLabel: "Cancel",
      onYes: async () => {
        const reply = await applyLinks({ fold });
        if (reply.error) {
          showMessage(reply.error, "danger", "Failed!", "top", "top-right", 0);
          return;
        }
        showMessage(`Linked ${reply.linked} categories${fold ? `, moved ${reply.moved} products` : ""}`, "success", "Done", "top", "top-right", 0);
        setPreview(null);
        onApplied();
      },
    });

  return (
    <section className="umb-card">
      <div className="umb-card__top">
        <div>
          <h3 className="umb-card__title">Link existing menu categories</h3>
          <p className="umb-muted">Groups every menu category that has no umbrella yet. Preview first; nothing changes until Apply.</p>
        </div>
        <button type="button" className="btn btn-light" disabled={busy} onClick={load}>Preview</button>
      </div>
      {preview && (
        <>
          <p className="umb-summary">{`${preview.category_count} menu categories into ${preview.groups.length} umbrellas`}</p>
          <label className="umb-fold">
            <input type="checkbox" checked={fold} onChange={(event) => setFold(event.target.checked)} />
            Also merge same-word sections inside each franchise (renames menu sections, cannot be undone here)
          </label>
          {fold && (
            <ul className="umb-list">
              {preview.folds.map((move) => <li key={move.keep_id}>{foldLine(move)}</li>)}
            </ul>
          )}
          <ul className="umb-list">
            {preview.groups.map((group) => (
              <li key={`${group.umbrella_name}-${group.umbrella_id}`}>
                <strong>{group.umbrella_name}</strong>
                {group.new && <Tag>New</Tag>}
                {group.review && <Tag color="orange">Review</Tag>}
                <span className="umb-muted">{membersLine(group)}</span>
              </li>
            ))}
          </ul>
          <button type="button" className="btn btn-primary" disabled={!preview.category_count && !(fold && preview.folds.length)} onClick={apply}>
            Apply
          </button>
        </>
      )}
    </section>
  );
}
